export const colorWhite = {
  white0: "#fff",
  white1: "#fefefe",
  white2: "#f2f4f5",
  white3: "#e4e5e9",
  white4: "#d0d5d4",
  white5: "#cccccc",
  black1: "#666",
  black2: "#aaa",

  colorwhite0: "#eeeef0",
  colorwhite1: "#eeeeff",
  colorwhite2: "#eeeef0",
  colorwhite3: "#f3ffff",
  colorwhite4: "#f7eef7",
  colorwhite5: "#ffeeee",

  opacitycyan1: "#66ffee44",
  opacityblue1: "#7777ff44",

  blue1: "#6666ff",
  blue2: "#bbbbff",
  red1: "#ff6666",
  teal1: "#33B7A6",
  teal2: "#CDEDE9",
  pink1: "#aa33b7",
  cyan1: "#31daf1",
  cyan2: "#e3fafa",
  yellow1: "#ffd966",
  icon: "",
};
export const colorDark = {
  white0: "#363846",
  white1: "#1f1e31",
  white2: "#27283c",
  white3: "#313048",
  white4: "#3f4155",
  white5: "#61637c",
  black1: "#9ea9cd",
  black2: "#68749a",

  colorwhite0: "#11110f",
  colorwhite1: "#101028",
  colorwhite2: "#292b37",
  colorwhite3: "#001122",
  colorwhite4: "#270727",
  colorwhite5: "#281010",

  opacitycyan1: "#990011bb",
  opacityblue1: "#006666bb",

  blue1: "#6666ff",
  red1: "#ff6666",
  teal1: "#33B7A6",
  teal2: "#CDEDE9",
  pink1: "#aa33b7",
  cyan1: "#31daf1",
  cyan2: "#e3fafa",
  yellow1: "#ffd966",
  icon: "Dark",
};
